import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatToggle } from '@blocks-react/components/Toggle';
import styles from '../MyEquipment.module.scss';
export const MyEquipmentToggleShareButton = ({ handleToggleChange, text, checked, classname }) => {
    const labelClass = classname ?? styles['drawer-toggle-text'];
    return (_jsxs(CatToggle, { checked: checked, onBlToggleChange: handleToggleChange, "data-testid": "toggle-change-id", label: "", children: [_jsx("span", { slot: "checked-label", className: labelClass, children: text }), _jsx("span", { slot: "unchecked-label", className: labelClass, children: text })] }));
};
